import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Priorities from "./components/Priorities";
import Donation from "./components/Donation";
import VoterRegistration from "./components/VoterRegistration";
import GetInvolved from "./components/GetInvolved";
import Social from "./components/Social";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import GalleryPage from "./pages/GalleryPage";
import LoadingScreen from "./components/LoadingScreen";

// Home Page Component
const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Priorities />
        <Donation />
        <VoterRegistration />
        <GetInvolved />
        <Social />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Check if user has already seen the loading screen in this session
    const hasSeenLoading = sessionStorage.getItem('hasSeenLoading');
    
    if (hasSeenLoading) {
      // Skip loading screen if already seen in this session
      setIsLoading(false);
      setShowContent(true);
    }
  }, []);

  const handleLoadingComplete = () => {
    // Mark as seen in this session
    sessionStorage.setItem('hasSeenLoading', 'true');
    setIsLoading(false);
    // Small delay to ensure smooth transition
    setTimeout(() => {
      setShowContent(true);
    }, 100);
  };

  return (
    <BrowserRouter>
      <div className="App">
        {isLoading && <LoadingScreen onComplete={handleLoadingComplete} />}
        
        {showContent && (
          <div className="animate-fade-in">
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/gallery" element={<GalleryPage />} />
            </Routes>
          </div>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
